import React, { useCallback, useMemo } from "react";

import { colorTokens } from "../../../../../../cssConstants";
import ColorPicker from "../../../../../common/ColorPicker";
import { DEFAULT_BUTTON_BACKGROUND_COLOR } from "../../common/Button/constants";
import { useComponentConfigContext } from "../../common/ComponentConfigContext";
import { ConfigSection, Field } from "../../common/ConfigPanel";
import { FilePickerConfigState } from "../types";

export default function DesignConfig() {
  const context = useComponentConfigContext();
  const { dispatch } = context;
  const state = context.state as FilePickerConfigState;

  const themeProperties = useMemo(() => {
    return (
      state.draftComponent.properties.theme_properties || {
        color: colorTokens.white,
        "background-color": DEFAULT_BUTTON_BACKGROUND_COLOR
      }
    );
  }, [state.draftComponent.properties.theme_properties]);

  const updateThemeProperties = useCallback(
    change => {
      dispatch({
        type: "UPDATE_COMPONENT_THEME_PROPERTIES",
        payload: {
          properties: {
            ...themeProperties,
            ...change
          }
        }
      });
    },
    [dispatch, themeProperties]
  );

  return (
    <ConfigSection title="Style">
      <Field>
        <label>Fill</label>
        <ColorPicker
          value={themeProperties["background-color"]}
          size="small"
          onChange={value => {
            updateThemeProperties({ "background-color": value });
          }}
        />
      </Field>
      <Field>
        <label>Text</label>
        <ColorPicker
          value={themeProperties["color"]}
          size="small"
          onChange={value => {
            updateThemeProperties({ color: value });
          }}
        />
      </Field>
    </ConfigSection>
  );
}
